export default "__VITE_ASSET__B0mDMt8K__"